<one-table>
  <one-table-content>
    <mat-table [dataSource]="dataSource" matSort multiTemplateDataRows
     cdkDropList
     [cdkDropListData]="dataSource.data"
     (cdkDropListDropped)="drop($event)">

      <ng-container matColumnDef="dragHandle">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon class="drag-handle-icon">drag_indicator</mat-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-checkbox
            (change)="$event ? selection.toggle(row) : null; selectedRow = row; updateSelectRowStatus();"
            (click)="$event.stopPropagation()"
            [checked]="selection.isSelected(row)"
            [disabled]="row.iconSets === 'yes-icon'"
          >
          </mat-checkbox>
        </mat-cell>
      </ng-container>
      
      <ng-container matColumnDef="selectType">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element" class="cf-template-select-box">
          <div *ngIf="element.selectType; else cftEditableSelect" class="one-cloned-select">
            <span>{{element.selectType}}</span>
            <mat-icon>expand_more</mat-icon>
          </div>
          <ng-template #cftEditableSelect>
            <one-select
            [formControl]="selectTypeFormControl"
            [list]="selectTypeList"
            [placeholder]="selectPlaceholder"
            [width]="selectWidth"
            appearance="outlined"
            size="small"
            required
            ></one-select>
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="selectText">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element; let i = dataIndex">
          <div class="cf-input-group" *ngIf="element.selectText; else cftEditableInput" >
            <div class="one-cloned-input">
              {{element.selectText}}
            </div>
            <div class="cf-span-button" *ngIf="element.selectType === 'Dropdown' && element.dropDownOpt">Options ({{element.dropDownOpt.length}})</div>
            <div class="cf-span-button" *ngIf="element.selectType === 'Radio' && element.radioOpt">Options ({{element.radioOpt.length}})</div>
          </div>

          <ng-template #cftEditableInput >
            <mat-form-field appearance="outline" class="cf-template-txt-box" oneFormField>
              <input matInput placeholder="Enter text..." [formControl]="selectTextFormControl" min="5" max="250" required/>
              <button mat-icon-button one-icon-button matSuffix (click)="selectTextFormControl.setValue('')">
                <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix>clear </mat-icon>
              </button>
            </mat-form-field>
            <button mat-flat-button class="cf-opt-button" (click)="dropDownFn(i, element)" *ngIf="(element.selectType === 'Dropdown' || selectTypeFormControl.value.label === 'Dropdown') && element.dropDownOpt">Options ({{element.dropDownOpt.length}})</button>
            <button mat-flat-button class="cf-opt-button" (click)="radioFn(i, element)" *ngIf="(element.selectType === 'Radio' || selectTypeFormControl.value.label === 'Radio') && element.radioOpt">Options ({{element.radioOpt.length}})</button>
          </ng-template>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="selectMandatory">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element" class="cf-template-select-box">
          <div *ngIf="element.selectMandatory; else cftEditableSelectMandatory" class="one-cloned-select">
            <span>{{element.selectMandatory}}</span>
            <mat-icon>expand_more</mat-icon>
          </div>
          <ng-template #cftEditableSelectMandatory>
            <one-select
            [formControl]="selectMandatoryFC"
            [list]="selectMandatoryList"
            [placeholder]="selectMandatoryPlaceholder"
            [width]="selectMandatoryWidth"
            appearance="outlined"
            size="small"
            required
            ></one-select>
          </ng-template>
        </mat-cell>
      </ng-container> 

      <ng-container matColumnDef="iconSets">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let element; let inx = dataIndex">
          <div *ngIf="(element.selectType === 'Dropdown' || selectTypeFormControl.value.label === 'Dropdown') && element.dropDownOpt" >
            <button mat-icon-button one-icon-button matSuffix title="Click to save feedback item" [ngClass]="(!selectTextFormControl.invalid && element.dropDownOpt.length > 0)? 'valid-feedback-item' : ''" *ngIf="element.iconSets === 'yes-icon'" [disabled]="selectTextFormControl.invalid || selectTypeFormControl.invalid || element.dropDownOpt.length === 0" (click)="addNewFeedbackOption(element, inx, selectTypeFormControl.value, selectTextFormControl.value, selectMandatoryFC.value)">
              <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix class="done-icon">yes</mat-icon>
            </button>
          </div>
          <div *ngIf="(element.selectType === 'Radio' || selectTypeFormControl.value.label === 'Radio') && element.radioOpt" >
            <button mat-icon-button one-icon-button matSuffix title="Click to save feedback item" [ngClass]="(!selectTextFormControl.invalid && element.radioOpt.length > 0)? 'valid-feedback-item' : ''" *ngIf="element.iconSets === 'yes-icon'" [disabled]="selectTextFormControl.invalid || selectTypeFormControl.invalid || element.radioOpt.length === 0" (click)="addNewFeedbackOption(element, inx, selectTypeFormControl.value, selectTextFormControl.value, selectMandatoryFC.value)">
              <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix class="done-icon">yes</mat-icon>
            </button>
          </div>
          <div  *ngIf="element.selectType === 'Question' || selectTypeFormControl.value.label === 'Question'" >
            <button mat-icon-button one-icon-button matSuffix title="Click to save feedback item" [ngClass]="!selectTextFormControl.invalid ? 'valid-feedback-item' : ''" *ngIf="element.iconSets === 'yes-icon'" [disabled]="selectTextFormControl.invalid || selectTypeFormControl.invalid" (click)="addNewFeedbackOption(element, inx, selectTypeFormControl.value, selectTextFormControl.value, selectMandatoryFC.value)">
              <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix class="done-icon">yes</mat-icon>
            </button>
          </div>
          <div  *ngIf="element.selectType === 'Checkbox' || selectTypeFormControl.value.label === 'Checkbox'" >
            <button mat-icon-button one-icon-button matSuffix title="Click to save feedback item" [ngClass]="!selectTextFormControl.invalid ? 'valid-feedback-item' : ''" *ngIf="element.iconSets === 'yes-icon'" [disabled]="selectTextFormControl.invalid || selectTypeFormControl.invalid" (click)="addNewFeedbackOption(element, inx, selectTypeFormControl.value, selectTextFormControl.value, selectMandatoryFC.value)">
              <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix class="done-icon">yes</mat-icon>
            </button>
          </div>
          <div  *ngIf="element.selectType === 'Attachment' || selectTypeFormControl.value.label === 'Attachment'" >
            <button mat-icon-button one-icon-button matSuffix title="Click to save feedback item" [ngClass]="!selectTextFormControl.invalid ? 'valid-feedback-item' : ''" *ngIf="element.iconSets === 'yes-icon'" [disabled]="selectTextFormControl.invalid || selectTypeFormControl.invalid" (click)="addNewFeedbackOption(element, inx, selectTypeFormControl.value, selectTextFormControl.value, selectMandatoryFC.value)">
              <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix class="done-icon">yes</mat-icon>
            </button>
          </div>
          <div>
            <button [matMenuTriggerFor]="feedbackOptionsMenu" title="Click to open menu" mat-icon-button one-icon-button matSuffix *ngIf="element.iconSets === 'more-icon'">
                <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix class="more-icon">more_vertical</mat-icon>
            </button>
            <mat-menu #feedbackOptionsMenu="matMenu" xPosition="before" oneMenu>
              <button style="display: none;" mat-menu-item [disabled]="ischeckforTemplate" (click)="addFeedbackToTemplate(element, inx)" class="cf-option-menu-btn">Add to templates</button>
              <button mat-menu-item (click)="deleteFeedbackFromTemplate(element, inx)" class="cf-option-menu-btn">Delete</button>
              <button mat-menu-item (click)="EditFeedbackFromTemplate(element, inx)" class="cf-option-menu-btn">Edit</button>
            </mat-menu>
          </div>
          <button mat-icon-button one-icon-button matSuffix title="Click to delete feedback item" *ngIf="element.iconSets === 'delete-icon'" (click)="deleteFeedbackFromTemplate(element, inx)">
              <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix class="delete-icon">delete</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <!-- <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row> -->
      
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{ disabled: row.disabled }"
        class="one-element-row cf-template-row"
        cdkDrag
        cdkDragLockAxis="y"
        [cdkDragDisabled]="row.disabled"
      ></mat-row>

    </mat-table>
  </one-table-content>
</one-table>